import { render, staticRenderFns } from "./RinvD_Invoice.vue?vue&type=template&id=33b4c4c1"
import script from "./RinvD_Invoice.vue?vue&type=script&lang=js"
export * from "./RinvD_Invoice.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports